<!--Report>Print Pre-Print Label页面-->
<template>
    <a-modal
            :title="$t('printLabel.qrCodeLabel')"
            v-model="visible"
            width="50%"
            :footer="null"
            :maskClosable="false"
            @cancel="cancel"
    >
        <!---下拉框选择Lable Type类型-->
        <a-row>
            <a-col align="center">
                <a-form-item class="genericFrom" aria-required="true">
                    <b>{{$t('printLabel.labelType')}}<span style="color: red"> * </span></b>
                    <a-select v-model="labelType" size="small" style="width:200px;" @change="labelTypeChage(labelType)">
                        <a-select-option v-for="item in selectArr" :key="item":value="item">
                            {{ labelTextMap[item] || item }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
            </a-col>
        </a-row>
        <br>

        <!--Carton-->
        <a-row v-if="labelType == 'CARTON_NO'">
            <a-col span="10" style="text-align: right">{{ $t('printLabel.NumberOfQrCodeLabelRequired') }}: </a-col>
            <a-col span="6">
                <a-input-number style="width: 100%;" :min="1" size="small" v-model="countCarton" :placeholder="$t('pubGicSet.InputaNumber')"/>
            </a-col>
            <a-col span="3">
                <a-button size="small" type="primary" style="margin-left: 5px;" @click="printLabel(countCarton,'Qr_Code_Label','CARTON_NO')">{{ $t('pubGicSet.Print') }}</a-button>
            </a-col>
        </a-row>


        <!--SO NO-->
        <a-row v-if="labelType == 'SO_NO'">
            <a-row>
                <a-col span="10" style="text-align: right">{{ $t('printLabel.NumberOfRelIdLabelRequired') }}: </a-col>
                <a-col span="6">
                    <a-input-number style="width: 100%;" :min="1" size="small" v-model="countSONo" :placeholder="$t('pubGicSet.InputaNumber')"/>
                </a-col>
                <a-col span="3">
                    <a-button size="small" type="primary" style="margin-left: 5px;" @click="printLabel(countSONo,'SO_No_Label','SO_NO')">{{ $t('pubGicSet.Print') }}</a-button>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px;">
                <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('pubGicSet.Reprint') }}: </a-col>
                <a-col :span="14" >
                    <a-input size="small" style="width: 80%;" v-model="reprintSoNo" :placeholder="$t('pubGicSet.Reprint')"/>
                    <a-button size="small" type="primary" style="margin-left: 4px;" @click="printReprintLabel(reprintSoNo,'SO_No_Label','SO_NO')" :disabled="reprintSoNo == null || reprintSoNo == ''">{{ $t('pubGicSet.Reprint') }}</a-button>
                </a-col>
            </a-row>
        </a-row>

        <!--SO No(Vertical)-->
        <a-row v-if="labelType == 'SO_NO_Vertical'">
            <a-row>
                <a-col span="10" style="text-align: right">{{ $t('printLabel.NumberOfRelIdLabelRequired') }}: </a-col>
                <a-col span="6">
                    <a-input-number style="width: 100%;" :min="1" size="small" v-model="countRelId" :placeholder="$t('pubGicSet.InputaNumber')"/>
                </a-col>
                <a-col span="3">
                    <a-button size="small" type="primary" style="margin-left: 5px;" @click="printLabel(countRelId,'SO_No_Vertical_Label','SO_NO_Vertical')">{{ $t('pubGicSet.Print') }}</a-button>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px;">
                <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('pubGicSet.Reprint') }}: </a-col>
                <a-col :span="14" >
                    <a-input size="small" style="width: 80%;" v-model="reprintSoNoVertical" :placeholder="$t('pubGicSet.Reprint')"/>
                    <a-button size="small" type="primary" style="margin-left: 4px;" @click="printReprintLabel(reprintSoNoVertical,'SO_No_Vertical_Label','SO_NO_Vertical')" :disabled="reprintSoNoVertical == null || reprintSoNoVertical == ''">{{ $t('pubGicSet.Reprint') }}</a-button>
                </a-col>
            </a-row>
        </a-row>

        <!--LPN-->
        <a-row v-else-if="labelType.startsWith('LPN_Label')">
            <a-row type="flex" justify="start" style="margin-bottom: 10px">
                <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('userlang.Warehouse') }}: </a-col>
                <a-col :span="14">
                    <a-select   show-search optionFilterProp="label" style="width: 90%" :placeholder="$t('publicLang.PleaseSelect')" v-model="warehouseVal" size="small" @change="warehoseChange">
                        <a-select-option v-for="item in warehouseData" :value="item.whsCode" :key="item.whsCode" :label="item.whsName">{{item.whsName}}</a-select-option>
                    </a-select>
                </a-col>
            </a-row>
            <a-row type="flex" justify="start" style="margin-bottom: 10px">
                <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('pubGicSet.LastPrinted') }}: </a-col>
                <a-col :span="12">{{LastLPN == null ? '---' : LastLPN}}</a-col>
            </a-row>
            <a-row style="margin-bottom: 10px">
                <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('pubGicSet.NumberOfLPNLabelRequired') }}: </a-col>
                <a-col :span="14" >
                    <a-input-number :min="1" size="small" style="width: 80%;" v-model="count" :placeholder="$t('pubGicSet.NumberOfLPNLabelRequired')"/>
                    <a-button size="small" type="primary" style="margin-left: 4px;" @click="printlpnbtn()" :disabled="count == null || warehouseVal == undefined">{{ $t('pubGicSet.Print') }}</a-button>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('pubGicSet.ReprintLPN') }}: </a-col>
                <a-col :span="14" >
                    <a-input size="small" style="width: 80%;" v-model="reprintLeftFromVal" :placeholder="$t('pubGicSet.ReprintLPN')"/>
                    <a-button size="small" type="primary" style="margin-left: 4px;" @click="printFromBtn" :disabled="reprintLeftFromVal == null">{{ $t('pubGicSet.Reprint') }}</a-button>
                </a-col>
            </a-row>
        </a-row>

        <!--LPN(IN)-->
        <a-row v-else-if="labelType == 'LPN_IN_Label'">
            <a-row type="flex" justify="start" style="margin-bottom: 10px">
                <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('userlang.Warehouse') }}: </a-col>
                <a-col :span="14">
                    <a-select style="width: 90%" :placeholder="$t('publicLang.PleaseSelect')" v-model="warehouseVal" size="small" @change="warehoseChangeLpnInOut(warehouseVal,'IN')">
                        <a-select-option v-for="item in warehouseData" :value="item.whsCode">{{item.whsName}}</a-select-option>
                    </a-select>
                </a-col>
            </a-row>
            <a-row type="flex" justify="start" style="margin-bottom: 10px">
                <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('pubGicSet.LastPrinted') }}: </a-col>
                <a-col :span="12">{{LastLPN == null ? '---' : LastLPN}}</a-col>
            </a-row>
            <a-row style="margin-bottom: 10px">
                <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('pubGicSet.NumberOfLPNLabelRequired') }}: </a-col>
                <a-col :span="14" >
                    <a-input-number :min="1" size="small" style="width: 80%;" v-model="count" :placeholder="$t('pubGicSet.NumberOfLPNLabelRequired')"/>
                    <a-button size="small" type="primary" style="margin-left: 4px;" @click="printlpninoutbtn('IN')" :disabled="count == null || warehouseVal == undefined">{{ $t('pubGicSet.Print') }}</a-button>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('pubGicSet.ReprintLPN') }}: </a-col>
                <a-col :span="14" >
                    <a-input size="small" style="width: 80%;" v-model="reprintLeftFromVal" :placeholder="$t('pubGicSet.ReprintLPN')"/>
                    <a-button size="small" type="primary" style="margin-left: 4px;" @click="printFromBtnInOut('IN')" :disabled="reprintLeftFromVal == null">{{ $t('pubGicSet.Reprint') }}</a-button>
                </a-col>
            </a-row>
        </a-row>

        <!--LPN(OUT)-->
        <a-row v-else-if="labelType == 'LPN_OUT_Label'">
            <a-row type="flex" justify="start" style="margin-bottom: 10px">
                <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('userlang.Warehouse') }}: </a-col>
                <a-col :span="14">
                    <a-select style="width: 90%" :placeholder="$t('publicLang.PleaseSelect')" v-model="warehouseVal" size="small" @change="warehoseChangeLpnInOut(warehouseVal,'OUT')">
                        <a-select-option v-for="item in warehouseData" :value="item.whsCode">{{item.whsName}}</a-select-option>
                    </a-select>
                </a-col>
            </a-row>
            <a-row type="flex" justify="start" style="margin-bottom: 10px">
                <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('pubGicSet.LastPrinted') }}: </a-col>
                <a-col :span="12">{{LastLPN == null ? '---' : LastLPN}}</a-col>
            </a-row>
            <a-row style="margin-bottom: 10px">
                <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('pubGicSet.NumberOfLPNLabelRequired') }}: </a-col>
                <a-col :span="14" >
                    <a-input-number :min="1" size="small" style="width: 80%;" v-model="count" :placeholder="$t('pubGicSet.NumberOfLPNLabelRequired')"/>
                    <a-button size="small" type="primary" style="margin-left: 4px;" @click="printlpninoutbtn('OUT')" :disabled="count == null || warehouseVal == undefined">{{ $t('pubGicSet.Print') }}</a-button>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('pubGicSet.ReprintLPN') }}: </a-col>
                <a-col :span="14" >
                    <a-input size="small" style="width: 80%;" v-model="reprintLeftFromVal" :placeholder="$t('pubGicSet.ReprintLPN')"/>
                    <a-button size="small" type="primary" style="margin-left: 4px;" @click="printFromBtnInOut('OUT')" :disabled="reprintLeftFromVal == null">{{ $t('pubGicSet.Reprint') }}</a-button>
                </a-col>
            </a-row>
        </a-row>

        <!--LPN (OUT Selectronic)-->
        <a-row v-else-if="labelType == 'LPN_SELECTRONIC'">
            <a-row type="flex" justify="start" style="margin-bottom: 10px">
                <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('userlang.Warehouse') }}: </a-col>
                <a-col :span="14">
                    <a-select show-search style="width: 90%" :placeholder="$t('publicLang.PleaseSelect')" v-model="warehouseVal" size="small" @change="warehoseChangeLpnInOut(warehouseVal,'OUT')">
                        <a-select-option v-for="item in warehouseData" :value="item.whsCode">{{item.whsName}}</a-select-option>
                    </a-select>
                </a-col>
            </a-row>
            <a-row type="flex" justify="start" style="margin-bottom: 10px">
                <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('pubGicSet.LastPrinted') }}: </a-col>
                <a-col :span="12">{{LastLPN == null ? '---' : LastLPN}}</a-col>
            </a-row>
            <a-row style="margin-bottom: 10px">
                <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('pubGicSet.Lpn') }}: </a-col>
                <a-col :span="14" >
                    <a-input :min="1" size="small" style="width: 80%;" v-model="lpnNo" :placeholder="$t('pubGicSet.Lpn')"/>
                    <!--                    <a-button size="small" type="primary" style="margin-left: 4px;" @click="printlpnSelectronicbtn('')" :disabled='lpnNo == "" || warehouseVal == undefined'>{{ $t('pubGicSet.Print') }}</a-button>-->
                    <a-button size="small" type="primary" style="margin-left: 4px;" @click="printView('')" :disabled='lpnNo == "" || warehouseVal == undefined'>{{ $t('publicLang.Preview') }}</a-button>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="20" style="text-align:center;">
                    <!--                    <a-button size="small" type="primary" style="margin-left: 100px;" @click="printlpnSelectronicbtn('1')" :disabled='lpnNo == ""'>{{ $t('pubGicSet.OuterCartonLabels') }}</a-button>-->
                    <a-button size="small" type="primary" style="margin-left: 100px;" @click="printView('1')" :disabled='lpnNo == ""'>{{ $t('pubGicSet.OuterCartonLabels') }}</a-button>
                    <!--                    <a-button size="small" type="primary" style="margin-left: 100px;" @click="printlpnSelectronicbtn('2')" :disabled='lpnNo == ""'>{{ $t('pubGicSet.InnerBoxLabels') }}</a-button>-->
                    <a-button size="small" type="primary" style="margin-left: 100px;" @click="printView('2')" :disabled='lpnNo == ""'>{{ $t('pubGicSet.InnerBoxLabels') }}</a-button>
                </a-col>
            </a-row>
        </a-row>
        <br>
    </a-modal>
</template>
<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import axios from "axios";
    import cookie from "../../../api/cookie"
    import webSocketPrint from "./webSocketPrint";
    import {mapState} from "vuex";
    export default{
        data(){
            return{
                visible: false,
                count: 1,
                countCarton:1,
                countRelId:1,
                countSONo:1,
                labelType:"",
                warehouseVal: undefined,
                LastLPN: null,
                reprintLeftFromVal: null,
                reprintSoNo: null,
                reprintSoNoVertical: null,
                lpnNo:"",
                printers:[],
                selectArr:[],
                labelTextMap: {
                    CARTON_NO: 'Carton No.',
                    SO_NO: 'SO No.',
                    SO_NO_Vertical: 'SO No. (Vertical)',
                    LPN_Label: 'LPN',
                    LPN_IN_Label: 'LPN (IN)',
                    LPN_OUT_Label: 'LPN (OUT)',
                    LPN_SELECTRONIC: 'LPN (OUT Selectronic)'
                },
            }
        },
        computed: {
            ...mapState(["whsCode"]),
        },
        methods:{
            show(){
                this.visible = true
                this.warehouseVal = undefined;
                this.selectArr = [];
                ajax.get(api.USERDROPDOWNWHSPRINT).then(res=>{
                    this.warehouseData = res.data.warehouseList
                    if(this.warehouseData.length == 1){
                        this.warehouseVal = this.warehouseData[0].whsCode
                        ajax.get(api.GENERICLASTLPN,{whsCode: this.warehouseData[0].whsCode}).then(res=>{
                            this.LastLPN = res.data.LastLPN
                        })
                    }
                })
                ajax.get(api.GENERICGETQRCODESELECT).then(res=>{
                    if(res.code == 200) {
                        if(res.data!=undefined && res.data != null) {
                            this.selectArr = res.data;
                        }
                    }
                })
            },
            cancel(){
                this.count = 1
                this.countCarton = 1;
                this.reprintLeftFromVal = null,
                    this.reprintSoNo = null,
                    this.reprintSoNoVertical = null,
                    this.labelType = ""
                this.lpnNo = ""
            },
            printLabel(count,name,code){
                let ajaxurl = ajax.ajaxUrl();
                let that = this
                axios.post(ajaxurl + api.PRINTPREVIEW, {
                        name: name,
                        count: count,
                        code: code,
                    }, {
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                }).then(res=>{
                    that.pubPdfMsgfn(res)
                })
            },
            printReprintLabel(value,name,code){
                let ajaxurl = ajax.ajaxUrl();
                let that = this
                axios.post(ajaxurl + api.PRINTPREVIEW, {
                        name: name,
                        value: value,
                        code: code
                    }, {
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                }).then(res=>{
                    that.pubPdfMsgfn(res)
                })
            },
            // paf接口返回值处理
            pubPdfMsgfn(res){
                let data = res.data;
                let fileReader = new FileReader();
                let that = this
                fileReader.onload = function() {
                    try {
                        let jsonData = JSON.parse(this.result);
                        if (jsonData.code) {
                            that.$customMessage.warning(jsonData.msg);
                            that.$store.commit("updataLoading", { pbLoading: false });
                            that.isBtnajax = false
                        }
                    } catch (err) {
                        that.pubPdfUploadOk(res)
                    }
                };
                fileReader.readAsText(data)
            },
            //pdf 成功下载方法
            pubPdfUploadOk(data){
                this.isBtnajax = false
                this.$store.commit("updataLoading", { pbLoading: false });
                let blob = new Blob([data.data], {type: "application/pdf;charset=utf-8"});
                let url = window.URL.createObjectURL(blob);
                window.open(url);
            },
            printFromBtn(){
                let ajaxurl = ajax.ajaxUrl();
                let that = this
                axios.post(ajaxurl + api.PRINTPREVIEW, {
                    name: 'LPN_Label',
                    LPN1: this.reprintLeftFromVal,
                    whsCode: this.warehouseVal,
                    labelType: this.labelType,
                    code:'LPN_Label'
                }, {
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                }).then(res=>{
                    that.pubPdfMsgfn(res)
                })
            },
            printFromBtnInOut(type){
                let ajaxurl = ajax.ajaxUrl();
                let that = this
                let codeType = '';
                if(type == 'IN') {
                    codeType = 'LPN_IN_Label';
                } else if(type == 'OUT') {
                    codeType = 'LPN_OUT_Label';
                }
                axios.post(ajaxurl + api.PRINTPREVIEW, {
                        name: 'LPN_IN_OUT_Label',
                        LPN1: this.reprintLeftFromVal,
                        whsCode: this.warehouseVal,
                        type: type,
                        code: codeType
                    }, {
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                }).then(res=>{
                    that.pubPdfMsgfn(res)
                })
            },
            printlpnbtn(){
                let ajaxurl = ajax.ajaxUrl();
                let that = this
                axios.post(ajaxurl + api.PRINTPREVIEW, {
                    name: 'LPN_Label',
                    count: this.count,
                    whsCode: this.warehouseVal,
                    labelType: this.labelType,
                    code:'LPN_Label'
                }, {
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                }).then(res=>{
//                    Invalid LPN Number.
                    that.pubPdfMsgfn(res)
                })
            },
            printlpninoutbtn(type){
                let ajaxurl = ajax.ajaxUrl();
                let that = this
                axios.post(ajaxurl + api.PRINTPREVIEW, {
                        name: 'LPN_IN_OUT_Label',
                        count: this.count,
                        whsCode: this.warehouseVal,
                        type: type,
                        code:'LPN_IN_OUT_Label',
                    }, {
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                }).then(res=>{
//                    Invalid LPN Number.
                    that.pubPdfMsgfn(res);
                    that.labelTypeChage(type);
                })
            },
            warehoseChange(val){
                if(this.labelType.startsWith("LPN_Label_")){
                    this.getLastLpn(this.labelType);
                }else {
                    ajax.get(api.GENERICLASTLPN,{whsCode: val}).then(res=>{
                        this.LastLPN = res.data.LastLPN
                    })
                }
            },
            getLastLpn(labelType){
                ajax.get(api.GETLASTLPNBYCODEMAST,{whsCode: this.warehouseVal,code: labelType}).then(res=>{
                    if(res.code == 200) {
                        this.LastLPN = res.data.LastLPN
                    }else {
                        this.LastLPN = "";
                    }
                })
            },
            warehoseChangeLpnInOut(val,type){
                ajax.get(api.GENERICLASTLPNBYTYPE,{whsCode: val,type: type}).then(res=>{
                    this.LastLPN = res.data.LastLPN
                })
            },
            labelTypeChage(type){
                if("LPN_IN_Label" == type || "IN" == type) {
                    ajax.get(api.GENERICLASTLPNBYTYPE,{whsCode: this.warehouseVal,type: "IN"}).then(res=>{
                        this.LastLPN = res.data.LastLPN
                    })
                } else if("LPN_OUT_Label" == type  || "OUT" == type) {
                    ajax.get(api.GENERICLASTLPNBYTYPE,{whsCode: this.warehouseVal,type: "OUT"}).then(res=>{
                        this.LastLPN = res.data.LastLPN
                    })
                } else if("LPN_Label" == type) {
                    ajax.get(api.GENERICLASTLPN,{whsCode: this.warehouseVal}).then(res=>{
                        this.LastLPN = res.data.LastLPN
                    })
                } else if("LPN_SELECTRONIC" == type) {
                    this.warehouseVal = this.whsCode
                    ajax.get(api.GENERICLASTLPN,{whsCode: this.whsCode}).then(res=>{
                        this.LastLPN = res.data.LastLPN
                    })
                }else if(type.startsWith("LPN_Label_")){
                    this.getLastLpn(type);
                }
            },
            // 获取用户本地ip的方法
            getUserIP (onNewIP) {
                let MyPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection
                let pc = new MyPeerConnection({
                    iceServers: []
                })
                let noop = () => {

                }
                let localIPs = {}
                let ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g
                let iterateIP = (ip) => {
                    if (!localIPs[ip]) onNewIP(ip)
                    localIPs[ip] = true
                }
                pc.createDataChannel('')
                pc.createOffer().then((sdp) => {
                    sdp.sdp.split('\n').forEach(function (line) {
                        if (line.indexOf('candidate') < 0) return
                        line.match(ipRegex).forEach(iterateIP)
                    })
                    pc.setLocalDescription(sdp, noop, noop)
                }).catch((reason) => {
                })
                pc.onicecandidate = (ice) => {
                    if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return
                    ice.candidate.candidate.match(ipRegex).forEach(iterateIP)
                }
            },
            printlpnSelectronicbtn(type){
                if(this.lpnNo!=null&&this.lpnNo!=""){
                    this.getPrinters();
                    //自动打印
                    let params = {
                        lpn: this.lpnNo,
                        ip: this.ip,
                        type: type
                    };
                    ajax.get(api.AUTOPRINTHTTPFILE,params).then(res => {
                        this.autoPrint(res);
                    })
                }
            },
            autoPrint(res){
                for (let i = 0; i < res.length; i++) {
                    if(res[i]==null){
                        continue;
                    }
                    if (res[i].type == null) {
                        continue;
                    }
                    if(res[i].errorMsg!=null&&res[i].errorMsg!=""){
                        continue;
                    }
                    if(res[i].printerName==null||res[i].printerName==""){
                        continue;
                    }
                    console.log("printerNames:"+res[i].printerName);
                    let printerName = "";
                    let printerNames = res[i].printerName.split(",");
                    for(var j = 0;j<this.printers.length;j++){
                        for(var k = 0;k<printerNames.length;k++){
                            if(this.printers[j].name==printerNames[k]){
                                printerName = printerNames[k];
                                break;
                            }
                        }
                        if(printerName!=""&&printerName!=null){
                            break;
                        }
                    }
                    console.log("printerName:"+printerName);
                    if(printerName!=""){
                        res[i].printerName = printerName;
                        if(res[i].fileBytes.length>125000){
                            let oldFileBytes = res[i].fileBytes;
                            let part = Math.ceil(oldFileBytes.length/125000);//分批数
                            for (let j = 0; j < part; j++)
                            {
                                let fileBytes = "";
                                if (oldFileBytes.length>125000) {
                                    fileBytes = oldFileBytes.substring(0, 125000);
                                    oldFileBytes = oldFileBytes.substring(125000, oldFileBytes.lenght);
                                } else {
                                    fileBytes = oldFileBytes.substring(0, oldFileBytes.lenght);
                                    oldFileBytes = "";
                                }
                                res[i].fileIndex = j;//当前发送位置
                                res[i].fileCount = part;//表示发送多次已发完
                                res[i].fileBytes = fileBytes;
                                webSocketPrint.doPrint("9999",JSON.stringify(res[i]));
                            }
                        }else{
                            res[i].fileCount = 1;//1表示一次发完
                            webSocketPrint.doPrint("9999",JSON.stringify(res[i]));
                        }
                    }
                }
            },
            printView(type){
                //预览文件
                let params = {
                    lpn: this.lpnNo,
                    type: type
                };
                ajax.post(api.PRINTVIEWHTTPFILE,params).then(res => {
                    if(res.code==200){
                        if(res.data){
                            let list = res.data.split(",");
                            for(let url of list){
                                window.open(url);
                            }
                        }
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
            getPrinters(){
                let that = this;
                if ("WebSocket" in window)
                {
                    // Create websocket
                    var ws = new WebSocket("ws://localhost:9999/print");
                    ws.onopen = function()
                    {
                        ws.send("{'Type':'SERVER_INFO'}");
                    };
                    ws.onmessage = function (evt)
                    {
                        var msg = evt.data;
                        try {
                            that.printers = JSON.parse(msg).printerServer.printers;
                        } catch (e) {
                        }
                    };
                    ws.onclose = function()
                    {

                    };
                }
                else
                {

                }
            },
        },
        mounted(){
            this.getUserIP((ip) => {
                this.ip = ip;
            });
        }
    }

</script>
<style scoped>

</style>